// extracted by mini-css-extract-plugin
export default {"shopRoot":"shop_shopRoot__M5wm3","shoppingDescription":"shop_shoppingDescription__Y5X7h","productGrid":"shop_productGrid__UYlPe"};